import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Breadcrumbs } from '../models/breadcrumbs';

@Injectable({
    providedIn: 'root',
})
export class BreadcrumbsService {
    private subject = new BehaviorSubject<Breadcrumbs[]>(this.emptyMessage());

    emptyMessage(): Breadcrumbs[] {
        return [{ section: '', link: '', class: '' }];
    }

    sendMessage(breadcrumbs: Breadcrumbs[]): void {
        this.subject.next(breadcrumbs);
    }

    clearMessage(): void {
        this.subject.next(this.emptyMessage());
    }

    getMessage(): Observable<Breadcrumbs[]> {
        return this.subject.asObservable();
    }
}
